'use strict';

/**
 * PLP quick-filters bar. Chips open the modal on their accordion; the bar sticks and unsticks
 * via an IntersectionObserver on a sentinel, avoiding a scroll listener.
 */

/**
 * Opens the accordion group whose values belong to the given refinement attribute.
 * @param {string} attributeId - refinement attribute id from the chip
 */
function openAccordionForAttr(attributeId) {
    const $item = $('.lvz-filter__checkbox[data-attr="' + attributeId + '"]')
        .first()
        .closest('.lvz-filter__group-item');
    if (!$item.length) return;

    // Let accordion.js own the open state, so a later tap on the toggle collapses it correctly.
    if (!$item.hasClass('is-open')) {
        $item.children('.accordion__toggle').trigger('click');
    }
    $item[0].scrollIntoView({ block: 'nearest' });
}

const STICKY_HEADER_IDS = ['lvz-top-banner', 'lvz-header-info-container', 'lvz-header-template'];

/**
 * @returns {number} lowest point the sticky headers currently occupy, which is where the bar
 *   must pin to avoid sliding under them
 */
function headerStickyOffset() {
    return STICKY_HEADER_IDS.reduce(function (maxBottom, id) {
        const element = document.getElementById(id);
        if (!element) return maxBottom;
        const rect = element.getBoundingClientRect();
        if (rect.height < 1) return maxBottom;
        return rect.bottom > maxBottom ? rect.bottom : maxBottom;
    }, 0);
}

/**
 * Exposes the space taken by the bar, so anchors to the product grid land below it once stuck.
 * @param {HTMLElement} bar - the .lvz-quick-filters element
 */
function applyAnchorOffset(bar) {
    const marginBottom = parseFloat(window.getComputedStyle(bar).marginBottom) || 0;
    bar.parentElement.style.setProperty('--lvz-qf-anchor-offset', bar.offsetHeight + marginBottom + 'px');
}

/**
 * Pins the bar right below the sticky header and shifts the sticky-visual trigger by the same
 * offset, so it turns "stuck" when it reaches the header bottom rather than the viewport top.
 * @param {HTMLElement} bar - the .lvz-quick-filters element
 */
function applyStickyOffset(bar) {
    const offset = headerStickyOffset();
    bar.style.setProperty('--lvz-qf-top', offset + 'px');
    applyAnchorOffset(bar);
    return offset;
}

/**
 * Wires the sticky behaviour for one quick-filters bar via its preceding sentinel.
 * @param {HTMLElement} bar - the .lvz-quick-filters element
 */
function initSticky(bar) {
    const sentinel = bar.previousElementSibling;
    if (!sentinel || bar.dataset.stickyBound || !window.IntersectionObserver) return;
    bar.dataset.stickyBound = 'true';

    const offset = applyStickyOffset(bar);
    new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-sticky', !entries[0].isIntersecting);
    }, { rootMargin: -offset + 'px 0px 0px 0px' }).observe(sentinel);
}

function initAllSticky() {
    $('.lvz-quick-filters').each(function () {
        initSticky(this);
    });
}

module.exports = function () {
    $(document).on('click', '[data-lvz-rapid-open]', function () {
        openAccordionForAttr($(this).data('attr'));
    });

    // Mirrors onto the drawer checkbox and reuses the modal apply pipeline.
    $(document).on('change', '[data-lvz-rapid-toggle]', function () {
        const $toggle = $(this);
        const attr = String($toggle.data('attr'));
        const value = String($toggle.data('value'));
        const $box = $('.lvz-filter__checkbox[data-attr="' + attr + '"][data-value="' + value + '"]');
        const isChecked = $toggle.prop('checked');
        $box.prop('checked', isChecked);
        $('body').trigger('lvz:applyFilters', {
            trackingHint: {
                attr: attr,
                value: value,
                action: isChecked ? 'usage' : 'remove'
            }
        });
    });

    initAllSticky();
    // The bar is replaced after a filter is applied — re-bind the new one.
    $('body').on('search:updateDom', initAllSticky);
    let pendingFrame = null;
    function scheduleStickyOffset() {
        if (pendingFrame) return;
        pendingFrame = window.requestAnimationFrame(function () {
            pendingFrame = null;
            $('.lvz-quick-filters').each(function () {
                applyStickyOffset(this);
            });
        });
    }

    $(window).on('load resize scroll', scheduleStickyOffset);
    // The mobile search bar expands/collapses inside the sticky header: follow its new bottom edge.
    $(document).on('lavazza:headerSearchLayoutChange', scheduleStickyOffset);
};
